import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import VoucherRefList from '../../account/voucher/components/VoucherRefList';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormROValue from '../../../library/form/components/FormROValue1';

const InvActionPayment = (props) => {
    const { formObject, viewData } = props;

    const onActionSuccess = (action) => {
        formObject.refreshDependentForms(action);
    }

    if (!viewData)
        return (null)
        
    return (
        <div className="uiSingleColumn phViewContent">
            <div className="uiGridCol">
                <ul>
                    <li>
                        <div className="uiFlexDistributed">
                            <div className='uiFlexBox uiSpacerH5'>
                                <span className="uiLbl">
                                    <SarasTrans value="Payments" />
                                </span>
                                <span className="uiLblInLine uiSpacerH5">
                                    <SarasTrans value="Outstanding" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "outstanding" }} className='uiSpacerH5 uiHighlightBlue' />
                                <span className="uiLblInLine uiSpacerH5">
                                    <SarasTrans value="Total Paid" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "payment" }} className='uiSpacerH5 uiHighlightBlue' />
                                <FormButton formObject={formObject} rowKey="" className="uiActionButton" text={<SarasTrans value="Payment" />}
                                    action={{ actionId: "edit", paramName: "shVoucherLink",  
                                    actionParam: { collectpayment:"1", tdtId:"%dataList.valLDT" }, containerKey: "popup" }}
                                />
                            </div>
                        </div>
                        <div className="uiResetFloats">
                            <VoucherRefList viewData={formObject.childViews.voucherData} /> 
                        </div>
                        
                    </li>
                    <li>
                        <div>
                            <FormButton formObject={formObject} rowKey="" 
                                action={{ actionName: "invTrans", actionId: "refresh", actionMessage: "PleaseWait", actionType: "odoo",  paramName: "showPaymentStatus",
                                refreshMode: "dep",
                                onSuccess:onActionSuccess,
                                actionParam: { checkPaymentStatus:"1"}, containerKey: "popup"}}
                                className="uiActionButtonBlue uiSpacerL2" 
                                showText={1}
                                text={<SarasTrans value="Check Payment Status" />}
                                ></FormButton>
                            <FormButton formObject={formObject} rowKey="" 
                                action={{ actionName: "invTrans", actionId: "refresh", actionMessage: "PleaseWait", actionType: "odoo", paramName: "paymentList",
                                refreshMode: "dep",
                                onSuccess:onActionSuccess,
                                actionParam: { last5Payments:"1"}, containerKey: "popup"}}
                                className="uiActionButtonBlue uiSpacerL2" 
                                showText={1}
                                text={<SarasTrans value="Show Recent Payments" />}
                                ></FormButton>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default withView(InvActionPayment, "invTrans", "invTrnFooter,apiLog")